if (!customElements.get('nudra-countdown-bar')) {
  customElements.define(
    'nudra-countdown-bar',
    class NudraCountdownBar extends HTMLElement {
      connectedCallback() {
        this.clock = this.querySelector('[data-countdown-clock]');
        if (!this.clock) return;

        const minutes = parseInt(this.dataset.minutes, 10) || 30;
        const key = 'nudra-countdown-end';

        // Per-session countdown: sessionStorage is cleared when the browser
        // session ends, so the timer restarts fresh on the next visit. Within a
        // session it persists across page loads. Reset if missing or expired.
        let end = parseInt(sessionStorage.getItem(key), 10);
        if (!end || Number.isNaN(end) || end <= Date.now()) {
          end = Date.now() + minutes * 60 * 1000;
          sessionStorage.setItem(key, String(end));
        }
        this.end = end;

        this.render();
        this.timer = setInterval(() => this.render(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      render() {
        const remaining = Math.max(0, this.end - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const m = Math.floor(totalSeconds / 60);
        const s = totalSeconds % 60;
        this.clock.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        if (remaining <= 0) {
          clearInterval(this.timer);
        }
      }
    }
  );
}
